import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    FormControl,
} from "@mui/material";
import { useAuthStore } from "../../store/useAuthStore";
import Loader from "../../components/Loader/Loader";

const PasswordReset = () => {
    const [formData, setFormData] = useState({
        oldPassword: "",
        newPassword: "",
    });

    const { resetPassword, loading } = useAuthStore()

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await resetPassword(formData)
        } catch (error) {
            console.log(error)
        }
    };

    return (
        <Box
            sx={{
                border: "1px solid #C6C4C4",
                borderRadius: "13px",
                padding: "20px",
            }}
        >
            <Loader loading={loading} />
            <Typography
                variant="h2"
                sx={{
                    fontFamily: `"Quicksand", sans-serif`,
                    fontWeight: 700,
                    fontSize: { xs: "16px", md: "16px", lg: "20px" },
                    lineHeight: "28px",
                    color: "#008BFF",
                    textAlign: "left",
                    textTransform: "capitalize",
                }}
            >
                Reset Password
            </Typography>

            <Box
                component="form"
                sx={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "12px",
                    flexWrap: "wrap",
                    "& label": {
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: "400",
                        fontFamily: `"Lato", sans-serif`,
                        color: "#000",
                        marginBottom: "10px",
                    },
                    "& input": {
                        height: "50px",
                        paddingTop: "0",
                        paddingBottom: "0",
                    },
                    "& .MuiFilledInput-root": {
                        borderRadius: "4px",
                    },
                    "& .MuiInputBase-root.MuiFilledInput-root::before": {
                        content: "none",
                    },
                    "& .MuiFormControl-root": {
                        width: "100%",
                    },
                    "& input::placeholder": {
                        color: "#999999",
                    },
                    "& .formControl": {
                        width: "48%",
                    },
                }}
                noValidate
                autoComplete="off"
            >
                <FormControl className="formControl">
                    <label>Old Password</label>
                    <TextField
                        name="oldPassword"
                        placeholder="Old Password"
                        type="password"
                        variant="filled"
                        value={formData.oldPassword}
                        onChange={handleChange}
                    />
                </FormControl>

                <FormControl className="formControl">
                    <label>New Password</label>
                    <TextField
                        name="newPassword"
                        placeholder="New Password"
                        type="password"
                        variant="filled"
                        value={formData.newPassword}
                        onChange={handleChange}
                    />
                </FormControl>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    marginTop: "30px",
                    "& a": {
                        fontSize: "16px",
                        lineHeight: "24px",
                        marginRight: "30px",
                        color: "#000",
                    },
                }}
            >
                <a href="/login">Cancel</a>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{
                        display: "block",
                        textAlign: "center",
                        background: "#008BFF",
                        width: "203px",
                        height: {
                            xs: "36px",
                            sm: "36px",
                            md: "45px",
                            lg: "56px",
                        },
                        borderRadius: "4px",
                        color: "#FAFAFA",
                        boxShadow: "none",
                        fontFamily: `"Quicksand", sans-serif`,
                        fontWeight: 500,
                        fontSize: {
                            xs: "12px",
                            sm: "15px",
                            md: "15px",
                            lg: "16px",
                        },
                        lineHeight: {
                            xs: "18px",
                            sm: "20px",
                            md: "22px",
                            lg: "24px",
                        },
                        textTransform: "capitalize",
                    }}
                >
                    Save Password
                </Button>
            </Box>
        </Box>
    );
};

export default PasswordReset;
